  function getSave(){
    let moneyFormat = null;
    let comparePrice = 0
    setTimeout(()=>{
      $(".cart-item").each((idx,el)=>{
        moneyFormat = $(el).attr("data-money-format")
        comparePrice = Number($(el).attr("data-compare-price")) + comparePrice
      })
      console.log(comparePrice,'----')
     moneyFormat&& $(".totals .save_price").text(moneyFormat.replace("{{amount}}",(comparePrice/100).toFixed(2)))
    },0)
  }
  
  window.onload=getSave;
document.addEventListener('cart::drawer::open',getSave);
  document.addEventListener('drawer:menu:open',getSave);
  document.addEventListener('custom_cart_change',getSave);
  document.addEventListener('cart:swiper:update',getSave);